export default "__VITE_ASSET__CogyRoZJ__"